import { render, staticRenderFns } from "./single_annotation.vue?vue&type=template&id=4330c108&scoped=true&"
import script from "./single_annotation.vue?vue&type=script&lang=ts&"
export * from "./single_annotation.vue?vue&type=script&lang=ts&"
import style0 from "./single_annotation.vue?vue&type=style&index=0&id=4330c108&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4330c108",
  null
  
)

export default component.exports